import React, { useContext, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppContext } from '../../context';
import KBList from './List';
import { KB_NAV_ITEMS } from './navItems';
import FeaturesManager from 'utils/features/FeaturesManager';

FeaturesManager.registerFeature({
  id: 'knowledgeBase',
  name: 'Knowledge Base',
  description: 'Enable internal Knowledge Base for Lexipol staff',
  enabled: false,
  maxEnv: 'prod',
});

export default function KB() {
  const { setCurrentModule, registerNavItems, isLexipolStaff, isFeatureEnabled } = useContext(AppContext);

  useEffect(() => {
    setCurrentModule('kb');
    registerNavItems('kb', KB_NAV_ITEMS);
  }, [setCurrentModule, registerNavItems]);

  // Redirect if not Lexipol staff or feature not enabled
  if (!isLexipolStaff || !isFeatureEnabled('knowledgeBase')) {
    return <Navigate to='/dashboard' />;
  }

  return (
    <Routes>
      <Route
        index
        element={<Navigate to='core-concepts' />}
      />
      <Route
        path=':articleId'
        element={<KBList />}
      />
    </Routes>
  );
}
